"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CompanyAvatar = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../../../components/atoms/Flex"));

var _core = require("@material-ui/core");

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      height: 'auto'
    },
    avatar: {
      width: theme.spacing(14),
      height: theme.spacing(14)
    },
    link: {
      textDecoration: 'none',
      color: 'auto'
    }
  };
}); // TODO - perhaps rename and use a generic avatar component

var CompanyAvatar = function CompanyAvatar(_ref) {
  var className = _ref.className,
      name = _ref.name,
      link = _ref.link,
      photoUrl = _ref.photoUrl,
      props = _objectWithoutProperties(_ref, ["className", "name", "link", "photoUrl"]);

  var classes = useStyles();

  var component = /*#__PURE__*/_react.default.createElement(_Flex.default, {
    className: (0, _clsx.default)(classes.root, className),
    dir: "ttb",
    center: true
  }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
    className: classes.avatar,
    alt: name,
    src: photoUrl
  }), name && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    align: "center",
    variant: "h5"
  }, name));

  return link ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: link,
    className: classes.link
  }, component) : component;
};

exports.CompanyAvatar = CompanyAvatar;
CompanyAvatar.propTypes = {
  name: _propTypes.default.string,
  link: _propTypes.default.string,
  photoUrl: _propTypes.default.string
};
var _default = CompanyAvatar;
exports.default = _default;